var Handlebars = require('/root/code/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"card--content_wysiwyg\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.accreditees_body : stack1), depth0)) != null ? stack1 : "")
    + "</div>\n<div id=\"available-accreditee-profiles\"></div>\n<div id=\"accreditees-table\" class=\"table-container\"></div>\n";
},"useData":true});